var exports = {
  "kL": "GuildNotificationSettingsModal.module__container___ZHg2TF",
  "uW": "GuildNotificationSettingsModal.module__section___ZHg2TF",
  "Gf": "GuildNotificationSettingsModal.module__sectionTitle___ZHg2TF",
  "yV": "GuildNotificationSettingsModal.module__sectionDescription___ZHg2TF",
  "nv": "GuildNotificationSettingsModal.module__notificationSection___ZHg2TF",
  "RG": "GuildNotificationSettingsModal.module__suppressSection___ZHg2TF",
  "Sj": "GuildNotificationSettingsModal.module__mobilePushSection___ZHg2TF",
  "dY": "GuildNotificationSettingsModal.module__overridesSection___ZHg2TF",
  "dr": "GuildNotificationSettingsModal.module__overridesHeader___ZHg2TF",
  "bY": "GuildNotificationSettingsModal.module__overridesHeaderCell___ZHg2TF",
  "u1": "GuildNotificationSettingsModal.module__overridesHeaderCellLeft___ZHg2TF",
  "c": "GuildNotificationSettingsModal.module__overridesHeaderCellMute___ZHg2TF",
  "IC": "GuildNotificationSettingsModal.module__overrideItem___ZHg2TF",
  "sr": "GuildNotificationSettingsModal.module__overrideHeader___ZHg2TF",
  "yW": "GuildNotificationSettingsModal.module__channelInfo___ZHg2TF",
  "p": "GuildNotificationSettingsModal.module__channelIcon___ZHg2TF",
  "E8": "GuildNotificationSettingsModal.module__channelDetails___ZHg2TF",
  "HA": "GuildNotificationSettingsModal.module__channelName___ZHg2TF",
  "yb": "GuildNotificationSettingsModal.module__categoryName___ZHg2TF",
  "Z5": "GuildNotificationSettingsModal.module__mobileOverrideOptions___ZHg2TF",
  "Ue": "GuildNotificationSettingsModal.module__desktopNotificationOptions___ZHg2TF",
  "of": "GuildNotificationSettingsModal.module__checkboxCell___ZHg2TF",
  "DT": "GuildNotificationSettingsModal.module__removeButton___ZHg2TF",
  "kI": "GuildNotificationSettingsModal.module__iconTertiary___ZHg2TF",
};

module.exports = exports;
